/**
 * 银行发票信息
 */
import React, { Component } from 'react';
import ReactDOM, { render} from 'react-dom';
import lang from '../../../lang';
import Modal from 'boron/ScaleModal';

const noop = function(){};

const style = {
    modalStyle: {
         width: '500px'
    },
    contentStyle: {
        width: '500px',
        borderRadius: '6px',
        backgroundColor: '#fff',
        outline: 0
    },
    backdropStyle: {
        backgroundColor: "rgba(0,0,0, 0.5)"
    }
}

class NoticePop extends Component {
	
	componentDidMount() {
        this.showModal();
    }

    showModal(){
        this.refs.modal.show();
    }

    hideModal(){
        this.refs.modal.hide();   
    }
	
	render() {
		
		return (
			<Modal 
	            ref="modal"  
	            modalStyle={style.modalStyle}  
	            backdropStyle={style.backdropStyle} 
	            contentStyle={style.contentStyle}
	        >
	        	<div className="bank-pop">
	                <div className="bank-pop-hd">
	                	<h2>{lang.template('匯款注意事項')}</h2>
	                	<div className="close" onClick={()=>this.hideModal()}>x</div>
	                </div>
	                <div className="bank-pop-bd">
	                    <dl className="notes">
							<dt>
								{lang.template('注意事項：')}
							</dt>
							<dd dangerouslySetInnerHTML={{__html: lang.template("使用任一銀行金融卡在跨行 ATM 提款機轉帳為15元手續費。@@@@使用任一銀行金融卡在非跨行 ATM 提款機轉帳為0元手續費。@@@@虛擬帳號從生成之時起在24小時內有效，超時則無法付款成功。@@@@全年無休，24小時可用。@@@@分行別為：永豐銀行台北分行")}}></dd>									
						</dl>
						<dl className="notes">
							<dt>
								{lang.template('儲值服務時間：')}
							</dt>
							<dd className="time-info" dangerouslySetInnerHTML={{__html: lang.template("銀行APP匯款儲值轉帳時間24小時@@@@網路銀行匯款儲值轉帳時間 24小時@@@@ATM轉帳儲值時間 24小時@@@@銀行臨櫃匯款儲值轉帳時間 9:00 - 15:30@@@@郵局匯款儲值轉帳時間 8:00 - 17:00")}}></dd>
							<dd dangerouslySetInnerHTML={{__html: lang.template("銀行網路匯款儲值、ATM儲值一般15~60分鐘內到帳，其餘儲值方式的到帳時間為：周一到周四15:30 後匯款需隔天到帳，周五15 : 30 後匯款需下周一到帳。@@@@為維護自身權益，轉帳完成後請保留匯款單據。@@@@儲值過程中如果遇到任何問題，請聯繫我們客服。@@@@儲值金額將一次性轉為平台貨幣，無法分開帳號或同一帳號分多次儲值。")}}></dd>
						</dl>
	                </div>
	                <div className="bank-pop-ft">
	                    <button className="btn confirm" onClick={()=>this.hideModal()}>{lang.template('我了解')}</button>
	                </div>
	            </div>
	        </Modal>
        )
	}
}

module.exports = {
	create: function (cfg) {
		cfg = cfg || {};
		
		if (this.layer) {
			this.destroy();
		}
		var mountNode = this.createMountNode();
		
		this.layer = ReactDOM.render(
			<NoticePop {...cfg} onHide={this.onHide.bind(this)}/>,
			mountNode
		);
	},
	onHide: function() {
		if (this.layer) {
			this.destroy();	
		}
	},
	// 创建组件插入的DOM节点
	createMountNode: function() {
		this.mountNode = document.createElement("div");
		$(document.body).append(this.mountNode);
		return this.mountNode;
	},
	// 销毁弹出层
	destroy : function () {
		ReactDOM.unmountComponentAtNode(this.mountNode);
		$(this.mountNode).remove();
		delete this.layer;
	}
};


// WEBPACK FOOTER //
// ./js/component/recharge/bank/notice.js